export const TAX_TYPE_AMOUNT = 'amount';
export const TAX_TYPE_PERCENT = 'percent';

export const normalizeTaxType = (value) =>
  String(value || '').toLowerCase() === TAX_TYPE_PERCENT
    ? TAX_TYPE_PERCENT
    : TAX_TYPE_AMOUNT;

export const roundMoney = (value) => {
  const parsed = parseFloat(value);
  if (Number.isNaN(parsed)) {
    return 0;
  }
  return Math.round(parsed * 100) / 100;
};

export const formatUsd = (value) => `$${roundMoney(value).toFixed(2)}`;

export const isProductTaxable = (product) =>
  !!(
    product &&
    (product.is_taxable === true ||
      product.is_taxable === 'true' ||
      product.is_taxable === 1 ||
      product.is_taxable === '1')
  );

export const computeNonRxUnitTax = (product, priceOverride) => {
  if (!isProductTaxable(product)) {
    return 0;
  }
  const taxValue = roundMoney(product.tax_amount);
  if (normalizeTaxType(product.tax_type) === TAX_TYPE_PERCENT) {
    const price = roundMoney(
      priceOverride != null ? priceOverride : product.sell_price
    );
    return roundMoney((price * taxValue) / 100);
  }
  return taxValue;
};

export const getUnitPriceTaxTotal = (product, priceOverride) => {
  const price = roundMoney(
    priceOverride != null
      ? priceOverride
      : product && (product.sell_price != null ? product.sell_price : product.price)
  );
  const tax = computeNonRxUnitTax(product, price);
  return {
    price,
    tax,
    total: roundMoney(price + tax),
    isPercent: normalizeTaxType(product && product.tax_type) === TAX_TYPE_PERCENT,
    taxable: isProductTaxable(product),
  };
};

export const formatTaxDisplay = (product) => {
  if (!isProductTaxable(product)) {
    return '';
  }
  const breakdown = getUnitPriceTaxTotal(product);
  if (breakdown.isPercent) {
    return `${formatUsd(breakdown.tax)} (%)`;
  }
  return formatUsd(breakdown.tax);
};



// WEBPACK FOOTER //
// ./src/utils/nonRxTax.js